// student/src/pages/AuthHandoff.tsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient.ts";

const AuthHandoff: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;

    const params = new URLSearchParams(hash);
    const access_token = params.get("access_token");
    const refresh_token = params.get("refresh_token");
    const nextPath = params.get("next");

    if (!access_token || !refresh_token) {
      navigate("/practice", { replace: true });
      return;
    }

    (async () => {
      const { error } = await supabase.auth.setSession({
        access_token,
        refresh_token,
      });

      // Landing on /practice here would look like a successful login while
      // actually being signed out, so say so and ask for the password again.
      if (error) {
        console.error("Auth handoff failed:", error);
        navigate("/login", {
          replace: true,
          state: { authError: "That sign-in link has expired. Please log in again." },
        });
        return;
      }

      // Remove sensitive hash tokens from URL ASAP.
      window.history.replaceState(null, "", window.location.pathname);
      navigate(nextPath || "/practice", { replace: true });
    })();
  }, [navigate]);

  return null;
};

export default AuthHandoff;
